import React from "react";
import { useI18n } from "@/i18n";
import { InfraAIWordmark } from "@/components/InfraAIWordmark";

export const SITE_LOGO_URL = "/images/infraai-logo.png";

export function SiteBrand({ href, className = "", ...props }) {
  const { t } = useI18n();

  const inner = (
    <>
      <img
        src={SITE_LOGO_URL}
        alt="InfraAI"
        className="h-9 w-9 rounded object-cover shrink-0"
      />
      <div className="leading-tight min-w-0">
        <InfraAIWordmark variant="sm" className="text-[15px] tracking-tight text-ink" />
        <div className="text-[9px] font-mono tracking-widest2 text-amber/90">
          {t.footer.company}
        </div>
      </div>
    </>
  );

  const wrapperClass = `flex items-center gap-3 shrink-0 min-w-0 ${className}`.trim();

  if (href) {
    return (
      <a href={href} className={wrapperClass} {...props}>
        {inner}
      </a>
    );
  }

  return (
    <div className={wrapperClass} {...props}>
      {inner}
    </div>
  );
}
